import {
  Key,
  QrCode,
  Ruler,
  GitBranch,
  Search,
  MonitorPlay,
  Hammer,
  LayoutGrid,
  ArrowUpRight,
  Settings,
  Terminal,
  Globe,
  ShieldCheck,
  Cpu,
  RefreshCw,
  Calculator,
  Sparkles,
  Wrench,
  ChevronRight,
  X,
  Image,
  FileText,
  Briefcase,
  ArrowRight,
  Code,
  Repeat,
  Check,
  RotateCcw,
  Zap,
  Clock,
  Menu,
  DollarSign,
  CreditCard,
  Activity,
  Calendar,
  Type,
  Palette,
} from 'lucide-react'

export const toolsData = [
  {
    id: 1,
    size: 'large',
    title: 'Movie Finder',
    description: 'AI-powered streaming locator. Find where movies are playing globally.',
    url: '/moviefinder',
    category: 'Entertainment',
    icon: <MonitorPlay size={28} />,
    image: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 2,
    size: 'small',
    title: 'UT Thickness',
    description: 'Precision NDT calculation for material wall loss.',
    url: '/thicknesscalculator',
    category: 'NDT Tools',
    icon: <Ruler size={24} />,
    image: 'https://images.unsplash.com/photo-1696685662824-ca670d5bf2c7?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 3,
    size: 'small',
    title: 'Password Generator',
    description: 'Military-grade entropy for digital security.',
    url: '/passwordgenerator',
    category: 'Security',
    icon: <Key size={24} />,
    image: 'https://images.unsplash.com/photo-1584433144859-1fc3ab64a957?q=80&w=1630&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 4,
    size: 'medium',
    title: 'QR Creator Pro',
    description: 'Dynamic QR generation for industrial assets.',
    url: '/qrgenerator',
    category: 'IT Tools',
    icon: <QrCode size={24} />,
    image: 'https://images.unsplash.com/photo-1595079676339-1534801ad6cf?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 5,
    size: 'medium',
    title: 'Weld Check',
    description: 'Visual database for AWS/ASME weld discontinuities.',
    url: '/weldchecker',
    category: 'NDT Tools',
    icon: <GitBranch size={24} />,
    image: 'https://images.unsplash.com/photo-1501880622860-e1be39410ac1?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 6,
    size: 'small',
    title: 'NDT Hardness Calculator',
    description: 'Standard material hardness conversion.',
    url: '/hardness-converter',
    category: 'NDT Tools',
    icon: <Hammer size={24} />,
    image: 'https://images.unsplash.com/photo-1615160460316-b71cc7e4ca4d?q=80&w=729&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 7,
    size: 'small',
    title: 'API Tester',
    description: 'REST endpoint debugger for developers.',
    url: '/api-tester',
    category: 'IT Tools',
    icon: <Terminal size={24} />,
    image: 'https://images.unsplash.com/photo-1690585703267-de31ea667ef0?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 11,
    size: "small",
    title: "Tip Calculator",
    description: "Quickly calculate tips and split bills instantly.",
    url: "/tip-calculator",
    category: "Finance",
    icon: <DollarSign size={24} />,
    image: "https://images.unsplash.com/photo-1554224155-1696413565d3?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 12,
    size: "small",
    title: "Loan Calculator",
    description: "Calculate EMI and interest for home loans.",
    url: "/loan-calculator",
    category: "Finance",
    icon: <CreditCard size={24} />,
    image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 13,
    size: "small",
    title: "Pass-Checker",
    description: "Test the strength of your passwords instantly.",
    url: "/password-strength",
    category: "Security",
    icon: <ShieldCheck size={24} />,
    image: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 14,
    size: "small",
    title: "Unit Converter",
    description: "Convert length, weight, and temperature metrics.",
    url: "/unit-converter",
    category: "Utility",
    icon: <RefreshCw size={24} />,
    image: "https://images.unsplash.com/photo-1662137262938-106b823ccb21?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 15,
    size: "small",
    title: "BMI Calculator",
    description: "Track your Body Mass Index for fitness.",
    url: "/bmi-calculator",
    category: "Health",
    icon: <Activity size={24} />,
    image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 16,
    size: "small",
    title: "Age Calc",
    description: "Calculate exact age or difference between dates.",
    url: "/age-calculator",
    category: "Utility",
    icon: <Calendar size={24} />,
    image: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 17,
    size: "medium",
    title: "Currency Pro",
    description: "Real-time exchange for global currencies.",
    url: "/currency-converter",
    category: "Finance",
    icon: <DollarSign size={28} />,
    image: "https://images.unsplash.com/photo-1580519542036-c47de6196ba5?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 18,
    size: "small",
    title: "Text Case",
    description: "Convert text to UPPER, lower, or camelCase.",
    url: "/text-case",
    category: "Productivity",
    icon: <Type size={24} />,
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 19,
    size: "small",
    title: "Word Counter",
    description: "Count words and characters instantly.",
    url: "/word-counter",
    category: "Productivity",
    icon: <FileText size={24} />,
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 20,
    size: "medium",
    title: "Hex to RGB",
    description: "Convert color codes for web design projects.",
    url: "/hex-to-rgb",
    category: "Design",
    icon: <Palette size={28} />,
    image: "https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&q=80&w=800",
  }
];